import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelTextArea } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { ModelHtml } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import EmailEnvio from '../../../models/EmailEnvio';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:            { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    destino:       { exibir: 'main.emailenvio.destino', visivel: true, validacao: { obrigatorio: true, email: true } },
    assunto:       { exibir: 'main.emailenvio.assunto', visivel: true, validacao: { obrigatorio: true } },
    mensagem:      { exibir: 'main.emailenvio.mensagem', validacao: { obrigatorio: true } },
    dataenvio:     { exibir: 'main.emailenvio.dataenvio', visivel: true, tipo: 'date', time: true },
    ultimoretorno: { exibir: 'main.emailenvio.ultimoretorno', linhas: 18 },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

// dataenvio/ultimoretorno são preenchidos automaticamente pelo backend (afterCreate/afterUpdate
// de EmailEnvio) assim que o envio é processado — não editáveis pelo admin de um tenant de
// cliente. A publicação master pode editar/limpar dataenvio pra forçar reprocessamento de um
// envio que falhou (mesmo reforço replicado no backend, ver EmailEnvioController.update).
// ultimoretorno fica numa aba própria: no grid junto dos outros campos, o textarea não tinha
// espaço vertical suficiente para rolar um retorno mais longo.
class EmailEnvioFormulario extends Component {
    render() {
        const { model, contexto, permissoes } = this.props;
        const podeEditarDataEnvio = !!permissoes?.permiteacessogeral;
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.emailenvio.aba.dados')} leftIcon="pi pi-envelope mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.destino} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelCalendar model={{ ...model.dataenvio, disabled: !podeEditarDataEnvio }} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelTextInput model={model.assunto} contexto={contexto} />
                        </div>
                        <div className="field col-12 mt-3">
                            <ModelHtml model={model.mensagem} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header={UtilService.traduzir('main.emailenvio.aba.retorno')} leftIcon="pi pi-list mr-2">
                    <div className="grid">
                        <div className="field col-12 mt-3">
                            <ModelTextArea model={{ ...model.ultimoretorno, disabled: true }} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class EmailEnvioTemplate extends Component {
    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={EmailEnvio}
                model={model}
                identidade="main.emailenvio"
                permissoes={this.props.permissoes}
                icone="pi-envelope"
                storageKey="dt-emailenvios"
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <EmailEnvioFormulario model={m} contexto={ctx} permissoes={this.props.permissoes} />}
            />
        );
    }
}

export default EmailEnvioTemplate;
